import { createActions } from 'redux-actions';
import { addFlashMessage, clearMessage } from '../Flash';
import api from '../../../api';
import {
  normalizeJsonProject,
  getErrorMessages,
} from '../../../shared/helpers';

export const {
  setProject,
  setProjectFreelancers,
  setManagers,
  setFreelancers,
  changePageState,
  saveProjectFormInfo,
  resendConfirmationSuccess,
} = createActions({
  SET_PROJECT: project => ({ project }),
  SET_PROJECT_FREELANCERS: freelancers => ({ freelancers }),
  SET_MANAGERS: managers => ({ managers }),
  SET_FREELANCERS: freelancers => ({ freelancers }),
  CHANGE_PAGE_STATE: newPageState => ({ newPageState }),
  SAVE_PROJECT_FORM_INFO: value => ({ value }),
});

export const updateFreelancerBid = params => dispatch => {
  dispatch(clearMessage());
  return api
    .updateBid(params)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(addFlashMessage('Bid Submitted', 'success'));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      return dispatch(addFlashMessage(errors, 'error'));
    });
};

export const acceptBid = params => dispatch => {
  dispatch(clearMessage());
  return api
    .acceptBid(params)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(addFlashMessage('Bid Accepted', 'success'));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      return dispatch(addFlashMessage(errors, 'error'));
    });
};

export const getProject = id => dispatch => {
  dispatch(clearMessage());
  return api
    .getProject(id)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }
      return dispatch(setProject(normalizeJsonProject(json)));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });
};

export const getProjectFreelancers = id => dispatch => {
  dispatch(clearMessage());
  return api
    .getProjectFreelancers(id)
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(setProjectFreelancers(json.freelancers));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });
};

export const getManagers = () => dispatch => {
  dispatch(clearMessage());
  return api
    .getManagers()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(setManagers(json.managers));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });
};

export const getFreelancers = () => dispatch => {
  dispatch(clearMessage());
  return api
    .getFreelancers()
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(setFreelancers(json.freelancers));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });
};

export const resendConfirmationEmail = email => dispatch => {
  dispatch(clearMessage());
  return api
    .resendConfirmation({ email })
    .then(response => response.data)
    .then(json => {
      if (json.errors) {
        return dispatch(addFlashMessage(json.errors, 'error'));
      }

      return dispatch(addFlashMessage('Confirmation Resent', 'success'));
    })
    .catch(e => {
      const errors = getErrorMessages(e);
      dispatch(addFlashMessage(errors, 'error'));
    });
};



// WEBPACK FOOTER //
// ./src/store/actions/ProjectView/index.js